import React, { FC, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Input,
  Button,
  Modal,
  Row,
  Col,
  Dropdown,
  Menu,
  Switch,
  Radio,
} from "antd";
import { SearchOutlined, EllipsisOutlined } from "@ant-design/icons";
import _ from "lodash";
import { PAGE_TYPES } from "utils/PageTypes";
import { COPY_PAGE, GET_USERS_LIST } from "reducers/authReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  getCreatePagePublishTopic,
  getPagesRequestPublishTopic,
  getMembersPageCreatedPublishTopic,
  updatePagePublishTopic,
} from "hooks/MQTTConstants";
import moment from "moment";
import { Formik } from "formik";
import * as yup from "yup";
import { RootState } from "reducers/rootReducer";
import { SocketTopics } from "../../constants/enums";
import useLocalStorageService from "../../services/localStorage";
import { RID, CID } from "../../constants/localStoreKeys";
import { getRequestHeader } from "../../helpers/request/RequestPayload";
import { wrapRequestPayload } from "../../helpers/request/RequestPayload";
import { ReactSVG } from "react-svg";

const clientId = "60c83dcefe8cea1cd6699618";

function formatUserFilterText(text) {
  var result = "";
  let comp = text
    .trim()
    .split(" ")
    .filter((word) => word.length > 2)
    .map((x) => {
      return x + "*";
    });
  if (comp.length == 0) {
    return result;
  }

  comp.forEach((element) => {
    result += `@firstName:(${element})|@lastName:(${element})|`;
  });
  result += `@beamIds:{${comp.join("|")}}`;

  return `(${result})`;
}

function formatForRedis(text) {
  return text.replace(/-|_|\./g, function (x) {
    return `\\${x}`;
  });
}

let timeout: NodeJS.Timeout;

const CopyPageModal: FC<{
  isModalVisible?: any;
  setIsModalVisible?: any;
  onClose?: () => void;
  socket?: ISocket;
  currentLocation?: CurrentLocation;
  page_group?: any;
}> = ({
  isModalVisible,
  setIsModalVisible,
  onClose,
  socket,
  currentLocation,
}) => {
  const dispatch = useDispatch();
  const { users, allUsers, searchBds, findUsersToPage, userInfo } = useSelector(
    (state: RootState) => state.auth
  );
  const { searchResult, selectedItem, copyPageId } = useSelector(
    (state: RootState) => state.search
  );
  const [searchText, setSearchText] = useState<string>("");
  const [initialState, setInitialState] = useState<{ title: string }>({
    title: "",
  });

  const { getLocalStorageItem } = useLocalStorageService();
  const formValues = useRef(null);

  const [text, setText] = useState<string>("");
  const [groupTitleText, setGroupTitleText] = useState<string>("");
  const [selectedPages, setSelectedPages] = useState<any[]>([]);

  const [saving, setSaving] = useState<boolean>(false);

  const validationSchema = yup.object().shape({
    title: yup
      .string()
      .min(2, `Title has to be at least 2 characters`)
      .required("Title is required"),
  });

  useEffect(() => {
    dispatch(GET_USERS_LIST());
  }, []);

  const updatePage = (pageId) => {
    let members: any = {
      [localStorage.getItem("RID")]: {
        role: "edit",
        beamId: `${userInfo.firstName}.${userInfo.lastName}`,
      },
    };
    const timestamp = Date.now();
    const changes = [
      {
        op: "replace",
        path: "/persistent/dynamic/metadata/updatedAt",
        value: timestamp,
      },
    ];
    if (isModalVisible.type === "Copy") {
      changes.push({
        op: "replace",
        path: "/persistent/static/metadata/title",
        value: formValues.current?.title,
      });
      changes.push({
        op: "replace",
        path: "/persistent/static/metadata/createdAt",
        value: timestamp,
      });
      changes.push({
        op: "replace",
        path: `/persistent/static/metadata/members/users`,
        value: members,
      });
    };
    console.log('publish update page')
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      updatePagePublishTopic(),
      wrapRequestPayload({ changes, objectId: pageId }, pageId),
      (data) => {
        if (!data.status) {
          console.log("Publish error: ", data.message);
        }
      }
    );
  };

  useEffect(() => {
    // console.log(users);
    if (copyPageId) {
      console.log("test copy page", copyPageId);
      updatePage(copyPageId.pageId);
      dispatch({
        type: "SET_COPY_PAGE",
        payload: undefined,
      });
      
      setSaving(false);
      handleCancel();
    }
  }, [copyPageId]);

  const handleCancel = () => {
    setIsModalVisible(undefined);
    onClose && onClose();
  };

  const handleOk = (values: any) => {
    if ((values.title && values.title !== "") || isModalVisible.type === 'Merge') {
      formValues.current = values;
      switch (isModalVisible.type) {
        case "Copy":
          dispatch(
            COPY_PAGE({
              pageAId: isModalVisible.pageId,
              pageBIds: [],
              operation: "copy",
              "attributes": [
                "removeMembers",
                // "appendMessages"
                "addMessages"
              ]
            })
          );
          break;
        case "Merge":
          dispatch(
            COPY_PAGE({
              pageAId: isModalVisible.pageId,
              pageBIds: selectedPages.map((x) => {
                return x.pageId;
              }),
              operation: "merge",
              "attributes": [
                // "substractMembers",
                "addMessages"
              ]
            })
          );
          break;
      }
      setSaving(true);
    }
  };

  const addPage = (page) => {
    setSelectedPages([...selectedPages, page]);
  };

  const removePage = (page) => {
    selectedPages.splice(
      selectedPages.findIndex((item) => item.userId === page.pageId),
      1
    );
    setSelectedPages([...selectedPages]);
  };

  return (
    <Modal
      title={`${isModalVisible.type} page`}
      visible={isModalVisible !== undefined}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal scrollable"
      footer={[]}
      destroyOnClose={true}
    >
      <Formik
        initialValues={initialState}
        // validationSchema={validationSchema}
        onSubmit={handleOk}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <>
          {isModalVisible.type === "Copy" &&
            <Row>
              <Col span={24}>
                <Input
                  onBlur={handleBlur}
                  name="title"
                  onChange={handleChange}
                  placeholder="Page Title"
                />
                <span className="error text-danger">
                  <small>
                    {errors && touched && touched["title"] && errors["title"]}
                  </small>
                </span>
              </Col>
            </Row>
}
            {isModalVisible.type === "Merge" && (
              <Row className="scrollable-body mt-4">
                <Col span={24}>
                  <Row className="d-flex mb-4">
                    <Col>
                      <h5>Select pages to merge</h5>
                    </Col>
                    <Col>
                      <p>{selectedPages.length} pages</p>
                    </Col>
                  </Row>
                  {selectedPages &&
                    selectedPages.map((page, index) => (
                      <Row className="person-item" key={index}>
                        <Col span={4}>
                          <ReactSVG
                            src={`/images/community-blue-icon.svg`}
                            className="colorable mark-icon"
                          />
                        </Col>
                        <Col span={13}>
                          <h5>
                            {page?.persistent?.static?.metadata?.title ||
                              `Page ${page.pageId}`}
                          </h5>
                        </Col>
                        <Col span={7} className="d-block t-right">
                          <Button
                            className="beam-btn orange-btn"
                            onClick={() => removePage(page)}
                          >
                            Remove
                          </Button>
                        </Col>
                      </Row>
                    ))}

                  {/* <Row className="mb-4">
                  <Col span={24}>
                  <Input
                    onChange={(e) => {
                      const value: string = e.target.value;
                      if (timeout) clearTimeout(timeout);
                      timeout = setTimeout(() => {
                        // dispatch(GET_USERS_LIST(value));
                        if (findUsersToPage) {
                          aggregateUser(findUsersToPage.queryId, value);
                        }

                      }, 500);
                    }}
                    placeholder="Search"
                    suffix={<SearchOutlined />}
                  />
                  </Col>
                </Row> */}
                  {searchResult &&
                    searchResult
                      .filter((x) => {
                        return x.pageId !== isModalVisible.pageId;
                      })
                      .map(
                        (page, index) =>
                          !selectedPages.find(
                            (item) => item.pageId === page.pageId
                          ) && (
                            <Row className="person-item" key={index}>
                              <Col span={4}>
                                <ReactSVG
                                  src={`/images/community-blue-icon.svg`}
                                  className="colorable mark-icon"
                                />
                              </Col>
                              <Col span={13}>
                                <h5>
                                  {page?.persistent?.static?.metadata?.title ||
                                    `Page ${page.pageId}`}
                                </h5>
                              </Col>
                              <Col span={7} className="d-block t-right">
                                {selectedPages.find(
                                  (item) => item.pageId === page.pageId
                                ) ? (
                                  <Button
                                    className="beam-btn orange-btn"
                                    onClick={() => removePage(page)}
                                  >
                                    Remove
                                  </Button>
                                ) : (
                                  <Button
                                    className="beam-btn green-btn"
                                    onClick={() => addPage(page)}
                                  >
                                    Merge
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          )
                      )}
                </Col>
              </Row>
            )}
            <Row className="action-grp mt-4 sticky-footer">
              <Col span={14} className="pr-2">
                <Button
                  className="beam-btn green-btn cover w-full"
                  loading={saving}
                  onClick={() => handleSubmit()}
                >
                  Save
                </Button>
              </Col>
              <Col span={10} className="pl-2">
                <Button
                  className="beam-btn orange-btn bordered w-full"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default CopyPageModal;
